import { AUTHORING_PROFILE, authoringMacroCapabilitiesSchema, pipelineHostTargetSchema,
  macroPackageRunReplySchema } from '@playcastdotio/Messaging';
import type { NativeMacroPackageBridge } from '../../services/playjector/NativeMacroPackageBridge';

/** Read-only native capability discovery, reached only through the owning local or authorized admin peer. */
export async function macroPackageCapabilities(payload: unknown, bridge?: Pick<NativeMacroPackageBridge, 'capabilities'>): Promise<Record<string, unknown>> {
  const input = payload as { requestId?: unknown; authoringProfile?: unknown } | null;
  const requestId = String(input?.requestId ?? '').slice(0, 128);
  if (!bridge) return { requestId, success: false, error: 'host_capabilities_unavailable' };
  try {
    const raw = await bridge.capabilities();
    if (input?.authoringProfile === AUTHORING_PROFILE) {
      const reply = raw as unknown as Record<string, unknown>;
      const capabilities = authoringMacroCapabilitiesSchema.safeParse(pickAuthoringCapabilities(reply));
      if (reply.outcome !== 'capabilities' || reply.inputsSent !== false
        || !pipelineHostTargetSchema.safeParse(reply.host).success || !capabilities.success) {
        return { requestId, success: false, error: 'authoring_host_capability_required' };
      }
      return { requestId, success: true, reply };
    }
    const reply = macroPackageRunReplySchema.parse(raw);
    if (reply.outcome !== 'capabilities') throw new Error('host_capabilities_invalid');
    return { requestId, success: true, reply };
  } catch { return { requestId, success: false, error: 'host_capabilities_unavailable' }; }
}

function pickAuthoringCapabilities(reply: Record<string, unknown>): Record<string, unknown> {
  return { pipelineVersion: reply.pipelineVersion, rawFormatVersions: reply.rawFormatVersions,
    sourceFormatVersions: reply.sourceFormatVersions, compiledFormatVersions: reply.compiledFormatVersions,
    compilerVersions: reply.compilerVersions, profile: reply.profile, scoringRule: reply.scoringRule,
    authoringProfiles: reply.authoringProfiles };
}
